/** Embedded eye-tracking shelf studies inside our surveys. Mirrors backend constants/eyetracking_constants.py. */

/** URL param carrying the participant id into the survey (SURVEY_TRACKING_PARAM). */
export const PIPED_MEDIA_RID_PARAM = 'iid';
export const pipedMediaPath = (surveyId: number, rid: string): string =>
  `/api/eyetracking/${surveyId}/piped-media/${encodeURIComponent(rid)}`;
export const PIPED_MEDIA_MAX_ATTEMPTS = 3;
export const PIPED_MEDIA_RETRY_MS = 1500;

export const studyLinkPath = (surveyId: number, rid: string, study: string): string =>
  `/api/eyetracking/${surveyId}/study-link/${encodeURIComponent(rid)}/${encodeURIComponent(study)}`;
export const STUDY_RETURN_ENDPOINT = '/api/eyetracking/return-embedded';
/** postMessage type sent by the study's Finish page (EMBED_FINISHED_MESSAGE). */
export const STUDY_FINISHED_MESSAGE = 'bp-et-finished';
export const STUDY_STATUS_SCREENOUT = 'screenout';
export const STUDY_IFRAME_ALLOW = 'camera; fullscreen; autoplay';

/** Respondent-facing text around the embedded study (no vendor name). */
export const STUDY_TEXT = {
  loading: 'Loading the shopping task…',
  saving: 'Saving your answers…',
  error: 'Something went wrong loading this part of the study.',
  retry: 'Try again',
} as const;

/** Researcher-facing labels for a stored study answer (session responses view). */
export const STUDY_ANSWER_TEXT = {
  title: 'Shopping task result',
  quality: 'Tracking quality',
  shelf: 'Shelf',
  bought: 'Chose',
  putBack: 'Picked up, put back',
  nothing: 'No choice (time ran out)',
  seconds: 's',
  practice: 'Practice',
  notAvailable: 'n/a',
} as const;
export const STUDY_PRACTICE_SHELF_ID = 'S00_PRACTICE';

/** Labels for what a per-respondent (piped) question showed, on the responses page. */
export const SHOWN_STIMULUS_TEXT = {
  title: 'Shown',
  packA: 'Pack A',
  packB: 'Pack B',
  chose: 'chose',
} as const;
